import { Component, HostListener, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterOutlet } from '@angular/router';
import { InactivityService } from '@ss/nta-hunter/common';
import { UserStore } from '@ss/shared/user';

@Component({
	selector: 'nta-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [
		RouterOutlet,
		MatIconModule
	]
})
export class AppComponent implements OnInit {

	inactivityStore = inject(InactivityService);

	user = inject(UserStore);

	router = inject(Router);

	logRouting = false;

	@HostListener('window:click')
	handleClick() {
		this.inactivityStore.handleInactiveCheck();
	}

	@HostListener('window:mousemove')
	handleMouseMove() {
		this.inactivityStore.handleInactiveCheck();
	}

	ngOnInit() {
		if (this.logRouting) {
			this.router.events.subscribe((event) => {
				// eslint-disable-next-line no-console
				console.log(event);
			});
		}
	}
}
